export default __webpack_public_path__ + "static/media/preorder_ar.da047a3c.svg";